export default __webpack_public_path__ + "static/media/anxious1.b789cfb9.png";